import {
  _throw,
  IllegalStateError,
  notNull,
} from "shared-ts-utils-core";
import { DateTime } from "luxon";
import { NullableSettingConfig } from "./NullableSettingConfig";

export const NullableDateTimeSetting: NullableSettingConfig<DateTime<boolean> | null> =
  {
    type: "dateTime",
    serialize: (value: DateTime<boolean> | null): string | null => {
      return notNull(
        value,
        (it) =>
          it.toISO() ??
          _throw(new IllegalStateError("Invalid DateTime: " + value))
      );
    },

    deserialize: (value: string | null): DateTime | null => {
      return value == null ? null : DateTime.fromISO(value);
    },
  };
